import React from 'react';
import { PageHeader, Page, PageBody } from "../base/Page";
import { Button, Row, Col, Panel, FormGroup } from 'react-bootstrap';
import API from "../base/API";
import Auth from "../auth/Auth";
import { getUser } from "../auth/Auth";
import FormField from "../base/FormField";
import { translate, languages } from "../base/Translation";

export default class UserProfile extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_user: "/user/save/:id",
			fetch_user: "/user/fetch/:id",
			fetch_fields: "/user/fetch/fields/:role"
		});

		// Experimental: Use passive data instead of state
		// To reduce re-rendering
		this.user = false;

		this.state = {
			loaded: false,
			fields: [],
			roles: [
				{ key: 1, value: "UNAUTHORIZED" },
				{ key: 2, value: "Používateľ prevádzky" },
				{ key: 3, value: "Používateľ klienta" },
				{ key: 4, value: "TOPTEST" },
				{ key: 5, value: "Admin" },
				{ key: 6, value: "Super Admin" }
			]
		};
	}

	componentDidMount() {
		this.fetch();
	}

	fetch() {
		this.api.request({
			route: "fetch_user",
			params: { id: getUser().id },
			success: (response) => {
				this.user = response;
				this.fetchFields(this.user.role);
			}
		});
	}

	save(evt) {
		this.api.request({
			route: "save_user",
			params: { id: this.user.id },
			data: this.user,
			created: (response) => {

			}
		});
	}

	fetchFields(role) {
		if (parseInt(role, 10) === 0) {
			this.setState({ fields: [] });
			return;
		}

		this.api.request({
			route: "fetch_fields",
			params: { role: role },
			success: (response) => {
				this.setState({ fields: response });
			}
		});
	}

	onChange(evt) {

		if (evt.target.name === "role") {
			this.fetchFields(evt.target.value);
		}

		let user = this.user;
		user[evt.target.name] = evt.target.value;
		this.user = user;
	}

	onMetaChange(evt) {
		let user = this.user;
		user.meta[evt.target.name] = evt.target.value;
		this.user = user;
	}

	render() {
		if (this.user === false) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}
		return (
			<Page>
				<PageHeader title={translate("Údaje používateľa")} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Profil")}>
								{this.state.fields.map(function (field) {
									return <FormField key={field} type="text" title={translate(field)} name={field} value={this.user.meta[field]} onChange={this.onMetaChange.bind(this)} />
								}.bind(this))}
							</Panel>
						</Col>
						<Col lg={6}>
							<Panel header={translate("Prihlasovacie údaje")}>
								<FormField type="text" title={translate("E-mail")} name="email" readOnly={true} value={this.user.email} onChange={this.onChange.bind(this)} />
								<FormField type="password" title={translate("Heslo")} name="password" value={typeof this.user.password !== "undefined" ? this.user.password : ""} onChange={this.onChange.bind(this)} />
								<FormField type="select" title={translate("Jazyk")} name="language" value={this.user.language} onChange={this.onChange.bind(this)} options={languages}/>
								<FormField type="hidden" value={this.user.role} />
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.save.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/user/UserProfile.js